import React from "react";
import { SERVER_URL } from "../config/config.js";
import "./biltyReport.css";
import ReportTable from "./ReportTable.js";
import { useEffect } from "react";

function TbbPartiesReport({ sessionObject }) {
    const columns = React.useMemo(
        () => [
            {
                Header: "Sr No",
                accessor: "sr_no",
                width: "110px",
                minWidth: "110px",
                canFilter: false,
            },
            {
                Header: "Party Name",
                accessor: "party_name",
                width: "420px",
                minWidth: "420px",
                canFilter: true,
            },
            {
                Header: "GST",
                accessor: "gst",
                width: "320px",
                minWidth: "320px",
                canFilter: true,
            },
            {
                Header: "Branches",
                accessor: "branches",
                width: "600px",
                minWidth: "600px",
                canFilter: true,
            },
        ],
        []
    );

    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [pageCount, setPageCount] = React.useState(0);
    const fetchIdRef = React.useRef(0);
    const sortIdRef = React.useRef(0);
    const [dateState, setDateState] = React.useState({
        date_from: new Date(),
        date_to: new Date(),
    });
    const [finalInput, setFinalInput] = React.useState({});

    useEffect(() => {
        console.log("tbb parties report loaded");
    }, []);

    const fetchData = React.useCallback(
        async ({ pageSize, pageIndex, sortBy, customFilters, dateObject }) => {
            const fetchId = ++fetchIdRef.current;

            setLoading(true);

            if (fetchId === fetchIdRef.current) {
                let newObject = {}
                newObject = { ...newObject, ...customFilters }
                delete newObject.fyear

                let inputData = {
                    paginate: { number_of_rows: pageSize, page_number: pageIndex + 1 },
                    sort_fields: sortBy,
                    filter_fields: newObject,
                };

                setFinalInput(inputData);

                let response = await fetch(SERVER_URL + "/report/tbb_parties_report", {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(inputData),
                });
                let resp = await response.json();


                if (resp["data"] && "total_rows" in resp) {
                    setData(resp["data"]);
                    setPageCount(Math.ceil(resp["total_rows"] / pageSize));
                }
                setLoading(false);
            }
        },
        []
    );

    return (
        <div className="page-marfatiya-wise tbb-parties-report">
            <div className="report-bilty">
                <div className="form-header">TBB Parties Report</div>
                <div className="report-bilty-table-container">
                    <ReportTable
                        columns={columns}
                        data={data}
                        fetchData={fetchData}
                        dateObject={dateState}
                        loading={loading}
                        pageCount={pageCount}
                    />
                </div>
            </div>
        </div>
    );
}

export default TbbPartiesReport;